// Libs
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import qs from 'qs';

// Constants
import { API_RESPONSE } from '@app/constants/apiDataConfig';

// Config
import { getConfig } from '@app/config';

const customBaseQuery = async (args, api, extraOptions) => {
  const config = getConfig();

  if (!config) {
    return { error: { status: 500, data: 'Config can not loaded yet' } };
  }

  const rawBaseQuery = fetchBaseQuery({
    baseUrl: config.REACT_APP_API_URL || '',
    credentials: 'include', // For cookie session
    validateStatus: (response, result) => {
      if (
        response.status !== 200 ||
        result.Code === API_RESPONSE.STATUS.FAILURE
      ) {
        return false;
      }

      return true;
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

  return rawBaseQuery(args, api, extraOptions);
};

export default createApi({
  baseQuery: customBaseQuery,
  tagTypes: ['Auth'],
  // eslint-disable-next-line no-unused-vars
  endpoints: (builder) => ({}),
});
